<script lang="ts">
	import { AVAILABLE_MODELS } from 'src/constants/models';
	import Select from '@astlai/common/Select.svelte';

	interface Props {
		model: string;
		label?: string;
		onchange?: (v: string) => void;
	}

	let { model = $bindable(), onchange = () => {}, label }: Props = $props();

	const grouped = Object.entries(
		AVAILABLE_MODELS.reduce(
			(acc, val) => ({ ...acc, [val.vendor]: [...(acc[val.vendor] || []), val] }),
			{} as Record<string, { key: string; name: string; vendor: string }[]>
		)
	);
</script>

<Select {label} {onchange} bind:value={model}>
	{#each grouped as [vendor, group]}
		<optgroup label={vendor}>
			{#each group as model}
				<option value={model.key}>{model.name}</option>
			{/each}
		</optgroup>
	{/each}
</Select>
